'use client';
import { useIsLaptop } from '@/_hooks/useBreakpoint';
import { DownIcon } from '@/_assets/icon-components';
import { IRedux } from '@/_store/types';
import {
  getActiveLanguage,
  getFilteredLanguages,
} from '@/_utils/Language';
import {
  PopoverBody,
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from '@/components/ui/popover';
import { usePathname, useRouter } from '@/i18n/navigation';
import { Box, Flex, IconButton, Stack, StackSeparator, Text } from '@chakra-ui/react';
import { useLocale } from 'next-intl';
import React, { Suspense, useState } from 'react';
import { useSelector } from 'react-redux';

const Languages = () => {
  const router = useRouter();
  const currentLocale = useLocale();
  const pathname = usePathname();
  const settings = useSelector((state: IRedux) => state.settings);
  const isLaptop = useIsLaptop();

  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState<string>(currentLocale);

  const websiteLanguages = settings?.data?.data?.web_site_languages || [];
  const filteredOptions = getFilteredLanguages(websiteLanguages);
  const activeLang = getActiveLanguage(value);

  const onChange = (value: string) => {
    if (filteredOptions.some((lang) => lang.value === value)) {
      setValue(value);
      router.push(pathname, { locale: value });
    }
  };

  return (
    <>
      <PopoverRoot open={isOpen} onOpenChange={(e) => setIsOpen(e.open)}>
        <PopoverTrigger asChild>
          <IconButton
            p={3}
            size={'xl'}
            rounded={'full'}
            fontWeight={600}
            bg={'gray.400'}
            color='text'
            variant={'plain'}
          >
            {activeLang?.icon}
            {!isLaptop && (
              <>
                {activeLang?.label?.substring(0, 3)}
                <Box
                  transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
                  transition='transform 0.2s ease'
                >
                  <DownIcon />
                </Box>
              </>
            )}
          </IconButton>
        </PopoverTrigger>
        <PopoverContent overflow={'hidden'} rounded={12} p={0} maxW={'200px'}>
          <Suspense>
            <PopoverBody p={0} rounded={12}>
              <Stack
                separator={<StackSeparator />}
                w='full'
                bg='background.card'
                color='text'
                gap={0}
              >
                {filteredOptions.map((el) => (
                  <Flex
                    key={el.id}
                    _hover={{
                      bgColor: 'background',
                    }}
                    p={3}
                    cursor={'pointer'}
                    gap={4}
                    align='center'
                    onClick={() => onChange(el.value)}
                  >
                    {el.icon}
                    <Text>{el.label}</Text>
                  </Flex>
                ))}
              </Stack>
            </PopoverBody>
          </Suspense>
        </PopoverContent>
      </PopoverRoot>
    </>
  );
};

export default Languages;
